export const CallAgents = new Map([
    ['agent_d588dabf862b4f0b0c6d21c8c0', 'Jessica']
])

export const CallAgentsNumbersByState = new Map([
    ['CA', '+12139557699'],
    ['OH', '+13308355076'],
    ['FL', '+19046640193'],
    ['TX', '+15123675777'],
    ['IL', '+17732954374'],
    // ['NY', '+13322492463']
])

export const agentsNumbers = [...CallAgentsNumbersByState.values()]